import createUseStyles from '@eduzz/houston-styles/createUseStyles';
import { EStatusAffiliation } from 'v2/interfaces/affiliation';

export const useStyles = createUseStyles((theme) => ({
  affiliationStatusCell: {
    textTransform: 'uppercase',
    [`&.--${EStatusAffiliation.PENDING}`]: {
      color: '#fabb0a',
    },
    [`&.--${EStatusAffiliation.APPROVED}`]: {
      color: '#4CAF50',
    },
    [`&.--${EStatusAffiliation.REPROVED}`]: {
      color: theme.feedbackColor.negative.pure,
    },
  },
  productTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  doneIcon: {
    color: '#4CAF50',
  },
  cancelIcon: {
    color: theme.feedbackColor.negative.pure,
  },
  affiliationRecruitmentCell: {
    textTransform: 'uppercase',
    '&.--enabled': {
      color: '#4CAF50',
    },
    '&.--disabled': {
      opacity: 0.7,
    },
  },
  inactiveTag: {
    display: 'block',
    border: `1px solid ${theme.feedbackColor.negative.pure}`,
    borderRadius: 4,
    backgroundColor: '#fdecea',
    color: theme.feedbackColor.negative.pure,
    textTransform: 'uppercase',
    padding: `0 ${theme.spacing.fn(2)}`,
    width: 'fit-content',
    fontSize: 10,
    marginTop: theme.spacing.fn(1),
  },
}));
